// ChartGridLine Component - Extracted from map
interface ChartGridLineProps {
  value: number;
  x1: number;
  x2: number;
  y: number;
  labelX: number;
}

export function ChartGridLine({ value, x1, x2, y, labelX }: ChartGridLineProps) {
  return (
    <g>
      <line x1={x1} y1={y} x2={x2} y2={y} stroke="rgba(128, 128, 128, 0.2)" strokeDasharray="4" />
      <text
        x={labelX}
        y={y}
        textAnchor="end"
        alignmentBaseline="middle"
        fontSize="12"
        fill="rgba(128, 128, 128, 0.7)"
      >
        {(value * 100).toFixed(0)}%
      </text>
    </g>
  );
}

export default ChartGridLine;
